import {Component, EventEmitter, Inject, Output, SecurityContext, ViewChild} from '@angular/core';
import {ModalDirective} from 'ng-uikit-pro-standard';
import {Localization} from '../../shared/enums/localization';
import {map, Observable} from "rxjs";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
  selector: 'app-agree-license-modal',
  templateUrl: './agree-license-modal.html',
  styleUrls: ['./agree-license-modal.scss']
})
export class AgreeLicenseModalComponent {

  @ViewChild('modal') modal: ModalDirective;
  @Output() confirmed = new EventEmitter<any>();
  public agreedToTerms: boolean;
  public readonly Localization = Localization;
  public license$: Observable<string>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: AgreeLicenseModalData,
    public readonly sanitizer: DomSanitizer,
  ) {
    this.license$ = data.license$.pipe(
      map(license => this.sanitizer.sanitize(SecurityContext.HTML, license))
    );
  }

  public onSubmit() {
    this.confirmed.emit();
  }

  public onAgreeToTermsChange(checked: boolean) {
    this.agreedToTerms = checked;
  }

  public show() {
    this.modal.show();
  }
}

export interface AgreeLicenseModalData {
  license$: Observable<string>;
}
